import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const fetchTransactionDetails = async (orderRef, token, accessToken) => {
  try {
    const response = await fetch(
      `${baseUrl}transaction-details?orderRef=${orderRef}&token=${token}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch transaction details: ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching transaction details:", error);
    return null;
  }
};
